import React from 'react'

export default function ContentEditor(props) {
  return (
    <div className="ContentEditor">
      <h3 className="text-center">Content Editor</h3>
    </div>
  )
}
